<template>
    <div :class="['download', type === 'mobile' ? 'download--mobile' : '']" @click="open">
        <img class="icon" src="@/assets/image9.png" alt="">
        <div class="text">
            Download White Paper for TANG DAO METAVERSE Project
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    type: String
})

const open = () => {
    if (props.type === 'mobile') {
        const pdfUrl = new URL('/White Paper for TANG DAO Metaverse - updated 01 Nov 2025.pdf.pdf', import.meta.url).href
        window.open(pdfUrl)
    } else {
        window.open(`${window.location.origin}/Whitepaper-pdf`)
    }
    
}
</script>

<style scoped>
.download{
    width: 100%;
    height: 74px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #F16323;
    border-radius: 12px;
    padding: 0 27px;
}
.icon{
    width: 34px;
    height: 34px;
    margin-right: 5px;
}
.text{
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
}
.download--mobile{
    height: 52px;
}
.download--mobile .icon{
    margin-right: 15px;
}
.download--mobile .text{
    font-size: 14px;
    line-height: 15px;
}
</style>